import { render, staticRenderFns } from "./TreatmentInputForm.vue?vue&type=template&id=0331024f&scoped=true&"
import script from "./TreatmentInputForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentInputForm.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentInputForm.vue?vue&type=style&index=0&id=0331024f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331024f",
  null
  
)

export default component.exports